import { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const filledButtonOverrides: ButtonOverrides = {
  Root: {
    props: {
      color: 'white',
      backgroundColor: 'primary8',
      _hover: {
        backgroundColor: 'primary9',
      },
      _active: {
        backgroundColor: 'primary9',
      },
    },
  },
};
